import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'src/app/core/services/cookie.service';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit, AfterViewInit {

  signupForm: FormGroup;
  submitted = false;
  error = '';
  loading = false;
  userId: number;

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private router: Router, private service: GeneralService, private cookieservice: CookieService) { }

  ngOnInit() {

    this.signupForm = this.formBuilder.group({
      FirstName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(25), Validators.pattern(/^[a-z]+$/i)]],
      Email: ['', [Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)]],
      Password: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/)]],
      LastName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(25), Validators.pattern(/^[a-z]+$/i)]],
      MobileNo: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
    });
  }

  ngAfterViewInit() {
    document.body.classList.add('authentication-bg');
    document.body.classList.add('authentication-bg-pattern');
  }

  // convenience getter for easy access to form fields
  get f() { return this.signupForm.controls; }

  /**
   * On submit form
   */
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.signupForm.invalid) {
      return;
    }

    this.loading = true;
    this.service.userRegister(this.signupForm.value).subscribe((res) => {
      if (res.error) {
        this.error = res.error;
        this.loading = false;
        return;
      } else {
        this.userId = res.data.recordsets[0].ID;
        this.cookieservice.setCookie('currentUser', JSON.stringify(this.userId), 1);
        this.service.setUserID(this.userId);
        this.loading = false;
        Swal.fire({
          title: 'Success',
          text: `A email has been send to ${this.signupForm.value.Email},
          Please check for an email and message from company and enter OTP.`,
          type: 'success',
          confirmButtonClass: 'btn btn-confirm mt-2'
        });
        this.router.navigate(['/account/confirm']);
      }
    },
    (error) => {                              //Error callback
      this.loading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
    
  }

  isValid(event) {
    if ((event.keyCode >= 48 && event.keyCode <= 57) && event.target.value.length < 10) {
    } else {
      return false;
    }
  }
}
